/**
 * UTM parameter override helper for CTA and Funnel links
 * Ensures consistent utm_source, utm_medium, utm_campaign, and campaign params
 * based on the current page code.
 */

/**
 * Build a URL with overridden UTM parameters
 * @param baseUrl - The base URL (may already contain some params)
 * @param pageCode - The current page code (e.g., 'inventory-finance')
 * @returns The URL with overridden UTM params as a string
 */
export function buildUrlWithUtmParams(baseUrl: string, pageCode: string): string {
  try {
    const url = new URL(baseUrl);

    // Override/set these params based on pageCode
    url.searchParams.set('utm_source', 'seo');
    url.searchParams.set('utm_medium', 'post');
    url.searchParams.set('utm_campaign', pageCode);
    url.searchParams.set('campaign', pageCode);

    return url.toString();
  } catch {
    // If URL is invalid, return baseUrl as-is
    return baseUrl;
  }
}
